export default __webpack_public_path__ + "static/media/dot-active.a80bec89.svg";